import { InvoiceTask, Pager } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation, useQuery } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';

/**
 * 1800. 請求タスク一覧
 * [GET] /workspaces/:identifier/invoice_tasks
 */
type Props = {
  identifier: string;
  page?: number;
  per?: number;
  billing_year_months?: string[];
  invoice_task_phase_ids?: number[];
  user_ids?: number[];
  business_partner_ids?: number[];
  team_ids?: number[];
  product_ids?: number[];
  subscribed?: boolean;
  sales_order_id?: number;
  archived?: boolean;
  enabled?: boolean;
};

export type InvoiceTasksResponse = {
  invoice_tasks: InvoiceTask[];
  pager: Pager;
}

const invoiceTasks = (props: Props): Promise<InvoiceTasksResponse> => {
  return axios.get(`/api/workspaces/${props.identifier}/invoice_tasks`, { params: props });
};

export const useInvoiceTasks = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'invoice_tasks', { ...props }],
    queryFn: () => invoiceTasks(props),
    enabled: props.enabled,
  })
}

export const useInvoiceTasksInvalidate = (identifier: string) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ['workspaces', identifier, 'invoice_tasks'] });
  };

  return { invalidate };
}